"use client";

import { useEffect } from "react";
import { getRelationshipArray } from "@/lib/utils/theme-configuration-class";
import { PROPERTY_TYPE_OPTIONS } from "@/lib/types/marketsuite/property-type";
import { MsListingTypeFilterBlock } from "@/payload-types";
import { MsSelectFilter, MsSelectFilterProps } from "../select/component";

type MsListingTypeFilterProps = Omit<MsSelectFilterProps, "blockType"> & Pick<MsListingTypeFilterBlock, "types">;

export const MsListingTypeFilter: React.FC<MsListingTypeFilterProps> = ({ types, field, onValueChange, ...props }) => {
	const options = getRelationshipArray(types)
		.map((type) => type.listingType)
		.filter((listingType) => listingType != null)
		.map((listingType) => ({
			code: listingType,
			label: PROPERTY_TYPE_OPTIONS.find((option) => option.value === listingType)?.label ?? listingType,
		}));

	const selected = props.selectedFilters["listing-type"] ?? [];
	const singleListingType = options.length === 1 ? options[0]!.code : undefined;

	useEffect(() => {
		if (!singleListingType) return;
		if (selected.length === 1 && selected[0] === singleListingType) return;

		field.handleChange([singleListingType]);
		onValueChange?.([singleListingType], "listing-type");
	}, [field, onValueChange, selected, singleListingType]);

	if (options.length < 2) return null;

	return <MsSelectFilter {...props} field={field} onValueChange={onValueChange} blockType="listing-type" filterData={options} />;
};
